import { Platform } from '@/core/Platform';
import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	slotSelection: {
		flex: 1,
		flexDirection: 'row',
		margin: 1,
		...Platform.select({
			web: {
				overflowX: 'auto',
			},
		}),
	},

	header: {
		flex: 1,
		flexDirection: 'row',
		height: 22,
	},

	timeHeader: {
		textAlign: 'center',
		width: 52,
	},
});
